<template>
  <div class="container">
    <div class="top_title">
      <router-link class="icon_back" :to="{name:'H010010'}" tag="span"></router-link>
      <p>配音分享</p>
      <span class="icon_search1" style="float: right;position: absolute;top: 0;right: 0.6rem;" @click="clickSearchBtn()"></span>
    </div>
    <div class="weui-flex top_tabs">
      <div class="weui-flex__item"><span :class="{active: tabFlag == 1}" @click="clickTab(1)">Top100(本月)</span></div>
      <div class="weui-flex__item"><span  :class="{active: tabFlag == 2}" @click="clickTab(2)">Top100(本周)</span></div>
      <div class="weui-flex__item"><span  :class="{active: tabFlag == 3}" @click="clickTab(3)">我的分享</span></div>
    </div>
    <div class="scroll_area" style="overflow-y: scroll">
      <div v-if="tempList.length > 0" class="items" style="overflow-y: auto">
        <a v-for="item,index in tempList"
                     class="item" :key="item.id" :href="item.I_URL">
          <div class="itemImg"><img :src="item.I_ICON" /></div>
          <div class="item_right">
            <p class="title">{{item.I_TITLE_1}}</p>
            <p class="sub_title">{{item.I_UNIT_NAME}}</p>
            <div class="remark"><span class="date">{{item.I_SHARE_TIME}}</span><span class="num">{{item.I_SHARE_NUM}}</span></div>
          </div>
        </a>
      </div>
      <p v-if="tempList.length > 0" style="height: 30px;line-height: 30px;text-align: center;color: #aaa;font-size: 0.9rem;">{{loadState}}</p>

      <template v-if="tempList.length == 0 && message!=''">
        <NoRecord :Message = "message"></NoRecord>
      </template>
    </div>

    <!--底部导航-->
    <Footer :navs="nav"></Footer>

    <div class="overlayer" >
      <div class="modal">
        <span class="icon_close" @click="closeModal()"></span>
        <div class="modal_contents">
          <p class="title">搜索/筛选</p>
          <div class="search">
            <input class="input_search" v-model="searchInput" type="text" placeholder="输入关键词搜索(书名/级别/内容)"/>
            <span class="icon_search" @click="clickSearch1" ></span>
          </div>
          <p class="level_title">级别筛选</p>
          <div class="select_items">
              <div  class="select_item">
                <span class="selection" :class="{active:I_LEVEL_CODE == '全部'}" @click="clickSearch2('全部')">全部</span>
              </div>
              <div v-for="item in overlayerList" class="select_item">
                <span class="selection" :class="{active:I_LEVEL_CODE == item.I_LEVEL_NAME}" @click="clickSearch2(item.I_LEVEL_NAME)">{{item.I_LEVEL_NAME}}</span>
              </div>
          </div>
          <div class="weui-flex bottom_btns">
            <div class="weui-flex__item" @click="reset()">
              重置
            </div>
            <div class="weui-flex__item" @click="clickConfirm()">
              确定
            </div>
          </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
  import DataRequestFactory from '@/factories/dataRequestFactory.js'
  import Footer from '../components/Footer.vue'
  import weui from 'weui.js'
  import NoRecord from '../components/NoRecord.vue'

  export default {
    name: '',
    data () {
      return {
        nav: {
          sy: true,
          jchd: false,
          yyst: false,
          wd: false,
        },
        tabFlag: 1,
        dataList: [],
        I_FLAG: "",
        overlayerList:[],
        I_LEVEL_CODE: "全部",
        searchInput: "",
        tempList: [],
        listLength: 0,
        count: 1,
        loadState: "加载中......",
        message: "",
      }
    },
    components: {
      Footer,
      NoRecord
    },
    created() {
      let params = {
        "I_FLAG":"本月",
        "I_SEARCH_FIELD":""
      }
      this.I_FLAG = '本月'
      DataRequestFactory.I120020(params).then((response) => {
        if(response.dataList.length == 0) {
          this.message = '无查询记录！'
        } else {
          this.message = ''
        }
        if(response.dataList.length <= 12) {
          this.loadState = "加载完成"
        } else {
          this.loadState = "加载中......"
        }
        this.dataList = response.dataList
        this.listLength = response.dataList.length
        this.tempList = this.dataList.splice(0,12)
      })

      DataRequestFactory.C110010().then((response) => {
        this.overlayerList = response.dataList
      })
    },
    methods: {
      reset() {
        this.searchInput = ""
        this.I_LEVEL_CODE = "全部"
      },
      closeModal() {
        $(".overlayer").css("display","none")
      },
      clickSearchBtn() {
        $(".overlayer").css("display","block")
        this.searchInput = ""
        this.I_LEVEL_CODE = "全部"
      },
      clickSearch1() {
        let params = {
          "I_FLAG":this.I_FLAG,
          "I_SEARCH_FIELD":this.searchInput
        }
        DataRequestFactory.I110010(params).then((response) => {
          $(".overlayer").css("display","none")
          $(".scroll_area").scrollTop(0)
          if(response.dataList.length == 0) {
            this.message = '无查询记录！'
          } else {
            this.message = ''
          }
          if(response.dataList.length <= 12) {
            this.loadState = "加载完成"
          } else {
            this.loadState = "加载中......"
          }
          this.dataList = response.dataList
          this.listLength = response.dataList.length
          this.tempList = this.dataList.splice(0,12)
        })
      },
      clickSearch2(value) {
        this.I_LEVEL_CODE = value
      },
      clickConfirm() {
        let params;
        if(this.I_LEVEL_CODE == '本月') {
          params = {
            "I_FLAG":this.I_FLAG,
            "I_LEVEL_NAME": "",
            "I_SEARCH_FIELD":this.searchInput,
          }
        } else {
          params = {
            "I_FLAG":this.I_FLAG,
            "I_SEARCH_FIELD":this.searchInput,
            "I_LEVEL_NAME": this.I_LEVEL_CODE
          }
        }
        DataRequestFactory.I120020(params).then((response) => {
          $(".overlayer").css("display","none")
          $(".scroll_area").scrollTop(0)
          if(response.dataList.length == 0) {
            this.message = '无查询记录！'
          } else {
            this.message = ''
          }
          if(response.dataList.length <= 12) {
            this.loadState = "加载完成"
          } else {
            this.loadState = "加载中......"
          }
          this.dataList = response.dataList
          this.listLength = response.dataList.length
          this.tempList = this.dataList.splice(0,12)
        })
      },
      clickTab(value) {
        if(value == 1) {
          this.tabFlag = 1
          let params = {
            "I_FLAG":"本月",
            "I_SEARCH_FIELD":""
          }
          this.I_FLAG = '本月'
          DataRequestFactory.I120020(params).then((response) => {
            $(".scroll_area").scrollTop(0)
            if(response.dataList.length == 0) {
              this.message = '无查询记录！'
            } else {
              this.message = ''
            }
            if(response.dataList.length <= 12) {
              this.loadState = "加载完成"
            } else {
              this.loadState = "加载中......"
            }
            this.dataList = response.dataList
            this.listLength = response.dataList.length
            this.tempList = this.dataList.splice(0,12)
          })
        } else if(value == 2) {
          this.tabFlag = 2
          let params = {
            "I_FLAG":"本周",
            "I_SEARCH_FIELD":""
          }
          this.I_FLAG = '本周'
          DataRequestFactory.I120020(params).then((response) => {
            $(".scroll_area").scrollTop(0)
            if(response.dataList.length == 0) {
              this.message = '无查询记录！'
            } else {
              this.message = ''
            }
            if(response.dataList.length <= 12) {
              this.loadState = "加载完成"
            } else {
              this.loadState = "加载中......"
            }
            this.dataList = response.dataList
            this.listLength = response.dataList.length
            this.tempList = this.dataList.splice(0,12)
          })
        } else if(value == 3) {
          this.tabFlag = 3
          let params = {
            "I_FLAG":"我的",
            "I_SEARCH_FIELD":""
          }
          this.I_FLAG = '我的'
          DataRequestFactory.I120020(params).then((response) => {
            $(".scroll_area").scrollTop(0)
            if(response.dataList.length == 0) {
              this.message = '无查询记录！'
            } else {
              this.message = ''
            }
            if(response.dataList.length <= 12) {
              this.loadState = "加载完成"
            } else {
              this.loadState = "加载中......"
            }
            this.dataList = response.dataList
            this.listLength = response.dataList.length
            this.tempList = this.dataList.splice(0,12)
          })
        }
      },
      //获取滚动条当前的位置
      getScrollTop() {
        var scrollTop = 0;
        if(document.documentElement && document.documentElement.scrollTop) {
          scrollTop = document.documentElement.scrollTop;
        } else if(document.body) {
          scrollTop = document.body.scrollTop;
        }
        return scrollTop;
      },
      //获取当前可视范围的高度
      getClientHeight() {
        var clientHeight = 0;
        if(document.body.clientHeight && document.documentElement.clientHeight) {
          clientHeight = Math.min(document.body.clientHeight, document.documentElement.clientHeight);
        } else {
          clientHeight = Math.max(document.body.clientHeight, document.documentElement.clientHeight);
        }
        return clientHeight;
      },
      //获取文档完整的高度
      getScrollHeight() {
        return Math.max(document.body.scrollHeight, $('.container')[0].scrollHeight);
      }
    },
    mounted() {
      let screenHeight = window.innerHeight;
      let fontSize = getComputedStyle(window.document.documentElement)['font-size']
      let heightDiff = screenHeight - parseInt(fontSize) * 7.8
      $(".scroll_area").css("height", heightDiff + "px"   )

      let vm = this
      $(".scroll_area").scroll(function(){
        if($(this)[0].scrollTop + $(this)[0].clientHeight + 15 > $(this)[0].scrollHeight) {
          vm.count++;
          if(vm.count <= Math.ceil(vm.listLength/3)) {
            if(vm.count + 1 >= Math.ceil(vm.listLength/3)) {
              vm.loadState = "加载完成"
            }
            var list = vm.dataList.splice(0, 3)
            vm.tempList = vm.tempList.concat(list);
          }
        }
      })
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import '../assets/css/pages/H120010.css';
  @import '../assets/css/common.css';
</style>



// WEBPACK FOOTER //
// src/pages/H120010.vue